/*示例
helperClass用来解决弹窗内拖拽式样式消失的问题
<DragSort key={key} onSortEnd={onSortEnd} helperClass="sortableHelper" useDragHandle>                          
    <DragItem key={1} index={1}>1    <DragHandle></DragHandle></DragItem>
    <DragItem key={2} index={2}>2</DragItem>   
    <DragItem key={3} index={3}>3</DragItem>                      
</DragSort>
.sortableHelper {
    z-index: 9999
}
*/
import { HolderOutlined } from '@ant-design/icons';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

export const DragHandle = SortableHandle((props) => {
    return props.children ? props.children : <HolderOutlined />;
});
export const DragItem = SortableElement((props) => {
    return props.children;
});

// 容器组件
export let DragSort = SortableContainer((props) => {
    return <div>{props.children}</div>; //必须用一个根节点包起来，不然拖拽的时候报错
});

export default DragSort;
